<template>
  <div>
    <div class="VedioTitle mt-h">
      <div class="pageurl">Home > Video</div>
      <div class="title text-uppercase">Video</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VedioTitle"
};
</script>

<style lang="less" scoped>
.pageurl {
  display: none;
}
@media screen and (min-width: 768px) {
  .VedioTitle {
    .pageurl {
      display: block;
      font-size: 0.12rem;
      font-family: Open Sans;
      font-weight: 400;
      color: rgba(195, 195, 195, 1);
      margin-left: 0.3rem;
      padding-top: 0.1rem;
    }
    .title {
      display: block;
      width: 100%;
      font-size: 0.3rem;
      padding: 0 0.3rem;
      font-family: FranklinGothic-Demi;
      color: #333333;
      font-weight: bold;
      margin-bottom: 10px;
      color: rgba(51, 51, 51, 1);
    }
  }
}
@media screen and (max-width: 768px) {
  .VedioTitle {
    .title {
      display: block;
      width: 100%;
      font-size: 0.7rem;
      font-family: FranklinGothic-Demi;
      color: #333333;
      font-weight: bolder;
      text-align: center;
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
    }
  }
}
</style>